import {events} from '../events';

export const setEntitlement = (name) => ({
    type: events.ENTITLEMENT_SET,
    payload: {
        name
    }
});
